export default __webpack_public_path__ + "static/media/330_business06-it-web.d2115a02.png";